import { put, select } from 'redux-saga/effects';

import { setCurrentJackpot, setNextJackpot } from 'core/widgets/Jackpot/actions';
import { OnJackpotChangedData } from '../../types';
import { IJackpot, PositionJackpot } from 'core/widgets/Jackpot/types';
import { Notifications } from 'types';
import { currentJackpotSelector, nextJackpotSelector } from 'core/widgets/Jackpot/selectors';

export function* onJackpotPausedSaga({
  type: notificationType,
  data: result,
}: OnJackpotChangedData) {
  if (notificationType === Notifications.JACKPOT_PAUSED) {
    const { tableId, jackpotId } = result;
    const { currentJackpot } = yield select(currentJackpotSelector);
    const nextJackpot: IJackpot = yield select(nextJackpotSelector);
    const isCurrent = jackpotId === currentJackpot.jackpotId;

    if (isCurrent) {
      yield put(setCurrentJackpot({ ...currentJackpot, isPaused: true }));
      return;
    }

    if (!isCurrent) {
      yield put(setNextJackpot({ ...nextJackpot, isPaused: true }));
    }
  }
}
